export const ROLES = {
    GLOBALADMIN: 'GLOBALADMIN',
    VIEWER: 'VIEWER',
    USER: 'USER',
    MANAGER: 'MANAGER',
    ADMIN: 'ADMIN',
  } as const;